<template>
  <RF-Dialog
    :cpntLargura='(tela * 0.90).toString() + "px"'
    :cpntStatus="statusGeral"
    :cpntOnFecharDialog='appProSitFisSimuladorFechar'>
    <template slot='titulo'>
      <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
      Simulador Situação Fiscal de Produto
    </template>

    <template slot='conteudo'>
      <div>
        <div class="app-pro-sit-fis-sim-filtros">
          <div>
            <div>
              <App-Select :data-time="time" :class="filtros.demanda.id"
                :cpntStatus='filtros.demanda.status'
                :cpntId='filtros.demanda.id'
                :cpntTabIndex='filtros.demanda.tabIndex'
                :cpntNome='filtros.demanda.nome'
                :cpntValue='filtros.demanda.value'
                :cpntMensagem='filtros.demanda.mensagem'
                :cpntMensagemTipo='filtros.demanda.mensagemTipo'
                :cpntDisabled='filtros.demanda.disabled'
                :cpntMostrar='filtros.demanda.mostrar'
                :cpntExplica='filtros.demanda.explica'
                :cpntPlaceholder='filtros.demanda.placeholder'
                :cpntValueRef='filtros.demanda.valueRef'
                :cpntRouter='filtros.demanda.router'
                :cpntField='filtros.demanda.field'
                :cpntWhere='filtros.demanda.where'
                :cpntAddButForm='filtros.demanda.addButForm'
                :cpntKeyMostra='filtros.demanda.keyMostra'
                :cpntTipoOrder='filtros.demanda.tipoOrder'
                :cpntOrder='filtros.demanda.order'
                :cpntOptions='filtros.demanda.options'
                :cpntOptionInicialNome='filtros.demanda.optionInicialNome'
                :cpntOptionInicialValue='filtros.demanda.optionInicialValue'
                :cpntKeyValue='filtros.demanda.keyValue'
                :cpntSearchMinimo='filtros.demanda.searchMinimo'
                :cpntMask='filtros.demanda.mask'

                :cpntOnBuscarOptions='filtros.demanda.onBuscarOptions'
                :cpntOnChange='filtros.demanda.onChange'
                :cpntOnBlur='filtros.demanda.onBlur'
                :cpntOnRealizaBusca='filtros.demanda.onRealizaBusca'
                :cpntOnKeyPressEnter='filtros.demanda.onKeyPressEnter'
                ref="demanda"
              ></App-Select>
            </div>
            <div>
              <App-Select :data-time="time" :class="filtros.modelo.id"
                :cpntStatus='filtros.modelo.status'
                :cpntId='filtros.modelo.id'
                :cpntTabIndex='filtros.modelo.tabIndex'
                :cpntNome='filtros.modelo.nome'
                :cpntValue='filtros.modelo.value'
                :cpntMensagem='filtros.modelo.mensagem'
                :cpntMensagemTipo='filtros.modelo.mensagemTipo'
                :cpntDisabled='filtros.modelo.disabled'
                :cpntMostrar='filtros.modelo.mostrar'
                :cpntExplica='filtros.modelo.explica'
                :cpntPlaceholder='filtros.modelo.placeholder'
                :cpntValueRef='filtros.modelo.valueRef'
                :cpntRouter='filtros.modelo.router'
                :cpntField='filtros.modelo.field'
                :cpntWhere='filtros.modelo.where'
                :cpntAddButForm='filtros.modelo.addButForm'
                :cpntKeyMostra='filtros.modelo.keyMostra'
                :cpntTipoOrder='filtros.modelo.tipoOrder'
                :cpntOrder='filtros.modelo.order'
                :cpntOptions='filtros.modelo.options'
                :cpntOptionInicialNome='filtros.modelo.optionInicialNome'
                :cpntOptionInicialValue='filtros.modelo.optionInicialValue'
                :cpntKeyValue='filtros.modelo.keyValue'
                :cpntSearchMinimo='filtros.modelo.searchMinimo'
                :cpntMask='filtros.modelo.mask'

                :cpntOnBuscarOptions='filtros.modelo.onBuscarOptions'
                :cpntOnChange='filtros.modelo.onChange'
                :cpntOnBlur='filtros.modelo.onBlur'
                :cpntOnRealizaBusca='filtros.modelo.onRealizaBusca'
                :cpntOnKeyPressEnter='filtros.modelo.onKeyPressEnter'
                ref="modelo"
              ></App-Select>
            </div>
            <!-- <div :class="filtros.modelo.toggles.value === true ? '' : 'filtrar_campo' ">
              <App-Toggles :data-time="time" :class="filtros.modelo.toggles.id"
                :cpntStatus='filtros.modelo.toggles.status'
                :cpntId='filtros.modelo.toggles.id'
                :cpntClassDivField='filtros.modelo.toggles.classDivField'
                :cpntNome='filtros.modelo.toggles.nome'
                :cpntValue='filtros.modelo.toggles.value'
                :cpntDisabled='filtros.modelo.toggles.disabled'
                :cpntMostrar='filtros.modelo.toggles.mostrar'
                :cpntMensagem='filtros.modelo.toggles.mensagem'
                :cpntMensagemTipo='filtros.modelo.toggles.mensagemTipo'
                :cpntOn='filtros.modelo.toggles.on'
                :cpntOff='filtros.modelo.toggles.off'
                :cpntExplica='filtros.modelo.toggles.explica'
                :cpntWidth='filtros.modelo.toggles.width'
                :cpntTabIndex='filtros.modelo.toggles.tabIndex'
                :cpntMask='filtros.modelo.toggles.mask'
                :cpntConfig='filtros.modelo.toggles.config'
                :cpntOnChange='filtros.modelo.toggles.onChange'
                :cpntOnBlur='filtros.modelo.toggles.onBlur'
                ref='modelo_toggles'
              ></App-Toggles>

              <App-Select :data-time="time" :class="filtros.modelo.id" v-if="filtros.modelo.toggles.value === false"
                :cpntStatus='filtros.modelo.status'
                :cpntId='filtros.modelo.id'
                :cpntTabIndex='filtros.modelo.tabIndex'
                :cpntNome='filtros.modelo.nome'
                :cpntValue='filtros.modelo.value'
                :cpntMensagem='filtros.modelo.mensagem'
                :cpntMensagemTipo='filtros.modelo.mensagemTipo'
                :cpntDisabled='filtros.modelo.disabled'
                :cpntMostrar='filtros.modelo.mostrar'
                :cpntExplica='filtros.modelo.explica'
                :cpntPlaceholder='filtros.modelo.placeholder'
                :cpntValueRef='filtros.modelo.valueRef'
                :cpntRouter='filtros.modelo.router'
                :cpntField='filtros.modelo.field'
                :cpntWhere='filtros.modelo.where'
                :cpntAddButForm='filtros.modelo.addButForm'
                :cpntKeyMostra='filtros.modelo.keyMostra'
                :cpntTipoOrder='filtros.modelo.tipoOrder'
                :cpntOrder='filtros.modelo.order'
                :cpntOptions='filtros.modelo.options'
                :cpntOptionInicialNome='filtros.modelo.optionInicialNome'
                :cpntOptionInicialValue='filtros.modelo.optionInicialValue'
                :cpntKeyValue='filtros.modelo.keyValue'
                :cpntSearchMinimo='filtros.modelo.searchMinimo'
                :cpntMask='filtros.modelo.mask'

                :cpntOnBuscarOptions='filtros.modelo.onBuscarOptions'
                :cpntOnChange='filtros.modelo.onChange'
                :cpntOnBlur='filtros.modelo.onBlur'
                :cpntOnRealizaBusca='filtros.modelo.onRealizaBusca'
                :cpntOnKeyPressEnter='filtros.modelo.onKeyPressEnter'
                ref="modelo"
              ></App-Select>
            </div> -->
     
            <div :class="filtros.id_p_pais.toggles.value === true ? '' : 'filtrar_campo'" v-if="([ 'NFCe' ].indexOf(filtros.modelo.value) !== -1 || [ 'NFCe' ].indexOf(filtros.modelo.value.id) !== -1) === false">
              <App-Toggles :data-time="time" :class="filtros.id_p_pais.toggles.id"
                :cpntStatus='filtros.id_p_pais.toggles.status'
                :cpntId='filtros.id_p_pais.toggles.id'
                :cpntClassDivField='filtros.id_p_pais.toggles.classDivField'
                :cpntNome='filtros.id_p_pais.toggles.nome'
                :cpntValue='filtros.id_p_pais.toggles.value'
                :cpntDisabled='filtros.id_p_pais.toggles.disabled'
                :cpntMostrar='filtros.id_p_pais.toggles.mostrar'
                :cpntMensagem='filtros.id_p_pais.toggles.mensagem'
                :cpntMensagemTipo='filtros.id_p_pais.toggles.mensagemTipo'
                :cpntOn='filtros.id_p_pais.toggles.on'
                :cpntOff='filtros.id_p_pais.toggles.off'
                :cpntExplica='filtros.id_p_pais.toggles.explica'
                :cpntWidth='filtros.id_p_pais.toggles.width'
                :cpntTabIndex='filtros.id_p_pais.toggles.tabIndex'
                :cpntMask='filtros.id_p_pais.toggles.mask'
                :cpntConfig='filtros.id_p_pais.toggles.config'
                :cpntOnChange='filtros.id_p_pais.toggles.onChange'
                :cpntOnBlur='filtros.id_p_pais.toggles.onBlur'
                ref='id_p_pais_toggles'
              ></App-Toggles>

              <App-Select :data-time="time" :class="filtros.id_p_pais.id" v-if="filtros.id_p_pais.toggles.value === false"
                :cpntStatus='filtros.id_p_pais.status'
                :cpntId='filtros.id_p_pais.id'
                :cpntTabIndex='filtros.id_p_pais.tabIndex'
                :cpntNome='filtros.id_p_pais.nome'
                :cpntValue='filtros.id_p_pais.value'
                :cpntMensagem='filtros.id_p_pais.mensagem'
                :cpntMensagemTipo='filtros.id_p_pais.mensagemTipo'
                :cpntDisabled='filtros.id_p_pais.disabled'
                :cpntMostrar='filtros.id_p_pais.mostrar'
                :cpntExplica='filtros.id_p_pais.explica'
                :cpntPlaceholder='filtros.id_p_pais.placeholder'
                :cpntValueRef='filtros.id_p_pais.valueRef'
                :cpntRouter='filtros.id_p_pais.router'
                :cpntField='filtros.id_p_pais.field'
                :cpntWhere='filtros.id_p_pais.where'
                :cpntAddButForm='filtros.id_p_pais.addButForm'
                :cpntKeyMostra='filtros.id_p_pais.keyMostra'
                :cpntTipoOrder='filtros.id_p_pais.tipoOrder'
                :cpntOrder='filtros.id_p_pais.order'
                :cpntOptions='filtros.id_p_pais.options'
                :cpntOptionInicialNome='filtros.id_p_pais.optionInicialNome'
                :cpntOptionInicialValue='filtros.id_p_pais.optionInicialValue'
                :cpntKeyValue='filtros.id_p_pais.keyValue'
                :cpntSearchMinimo='filtros.id_p_pais.searchMinimo'
                :cpntMask='filtros.id_p_pais.mask'

                :cpntOnBuscarOptions='filtros.id_p_pais.onBuscarOptions'
                :cpntOnChange='filtros.id_p_pais.onChange'
                :cpntOnBlur='filtros.id_p_pais.onBlur'
                :cpntOnRealizaBusca='filtros.id_p_pais.onRealizaBusca'
                :cpntOnKeyPressEnter='filtros.id_p_pais.onKeyPressEnter'
                ref="id_p_pais"
              ></App-Select>
            </div>
     
            <div :class="filtros.estado.toggles.value === true ? '' : 'filtrar_campo'" v-if="([ 'NFCe' ].indexOf(filtros.modelo.value) !== -1 || [ 'NFCe' ].indexOf(filtros.modelo.value.id) !== -1) === false">
              <App-Toggles :data-time="time" :class="filtros.estado.toggles.id"
                :cpntStatus='filtros.estado.toggles.status'
                :cpntId='filtros.estado.toggles.id'
                :cpntClassDivField='filtros.estado.toggles.classDivField'
                :cpntNome='filtros.estado.toggles.nome'
                :cpntValue='filtros.estado.toggles.value'
                :cpntDisabled='filtros.estado.toggles.disabled'
                :cpntMostrar='filtros.estado.toggles.mostrar'
                :cpntMensagem='filtros.estado.toggles.mensagem'
                :cpntMensagemTipo='filtros.estado.toggles.mensagemTipo'
                :cpntOn='filtros.estado.toggles.on'
                :cpntOff='filtros.estado.toggles.off'
                :cpntExplica='filtros.estado.toggles.explica'
                :cpntWidth='filtros.estado.toggles.width'
                :cpntTabIndex='filtros.estado.toggles.tabIndex'
                :cpntMask='filtros.estado.toggles.mask'
                :cpntConfig='filtros.estado.toggles.config'
                :cpntOnChange='filtros.estado.toggles.onChange'
                :cpntOnBlur='filtros.estado.toggles.onBlur'
                ref='estado_toggles'
              ></App-Toggles>

              <App-Select :data-time="time" :class="filtros.estado.id" v-if="filtros.estado.toggles.value === false"
                :cpntStatus='filtros.estado.status'
                :cpntId='filtros.estado.id'
                :cpntTabIndex='filtros.estado.tabIndex'
                :cpntNome='filtros.estado.nome'
                :cpntValue='filtros.estado.value'
                :cpntMensagem='filtros.estado.mensagem'
                :cpntMensagemTipo='filtros.estado.mensagemTipo'
                :cpntDisabled='filtros.estado.disabled'
                :cpntMostrar='filtros.estado.mostrar'
                :cpntExplica='filtros.estado.explica'
                :cpntPlaceholder='filtros.estado.placeholder'
                :cpntValueRef='filtros.estado.valueRef'
                :cpntRouter='filtros.estado.router'
                :cpntField='filtros.estado.field'
                :cpntWhere='filtros.estado.where'
                :cpntAddButForm='filtros.estado.addButForm'
                :cpntKeyMostra='filtros.estado.keyMostra'
                :cpntTipoOrder='filtros.estado.tipoOrder'
                :cpntOrder='filtros.estado.order'
                :cpntOptions='filtros.estado.options'
                :cpntOptionInicialNome='filtros.estado.optionInicialNome'
                :cpntOptionInicialValue='filtros.estado.optionInicialValue'
                :cpntKeyValue='filtros.estado.keyValue'
                :cpntSearchMinimo='filtros.estado.searchMinimo'
                :cpntMask='filtros.estado.mask'

                :cpntOnBuscarOptions='filtros.estado.onBuscarOptions'
                :cpntOnChange='filtros.estado.onChange'
                :cpntOnBlur='filtros.estado.onBlur'
                :cpntOnRealizaBusca='filtros.estado.onRealizaBusca'
                :cpntOnKeyPressEnter='filtros.estado.onKeyPressEnter'
                ref="estado"
              ></App-Select>
            </div>

            <div :style="filtros.contato.linha.length === 0 ? '' : 'margin-top: 5px;'">
              <App-Toggles :data-time="time" :class="filtros.contato.toggles.id" v-if="filtros.contato.linha.length === 0"
                :cpntStatus='filtros.contato.toggles.status'
                :cpntId='filtros.contato.toggles.id'
                :cpntClassDivField='filtros.contato.toggles.classDivField'
                :cpntNome='filtros.contato.toggles.nome'
                :cpntValue='filtros.contato.toggles.value'
                :cpntDisabled='filtros.contato.toggles.disabled'
                :cpntMostrar='filtros.contato.toggles.mostrar'
                :cpntMensagem='filtros.contato.toggles.mensagem'
                :cpntMensagemTipo='filtros.contato.toggles.mensagemTipo'
                :cpntOn='filtros.contato.toggles.on'
                :cpntOff='filtros.contato.toggles.off'
                :cpntExplica='filtros.contato.toggles.explica'
                :cpntWidth='filtros.contato.toggles.width'
                :cpntTabIndex='filtros.contato.toggles.tabIndex'
                :cpntMask='filtros.contato.toggles.mask'
                :cpntConfig='filtros.contato.toggles.config'
                :cpntOnChange='filtros.contato.toggles.onChange'
                :cpntOnBlur='filtros.contato.toggles.onBlur'
                ref='contato_toggles'
              ></App-Toggles>

              <!-- CRIA O BOTÃO PARA SELECIONAR TODOS -->
              <!-- <App-Button v-if="filtros.contato.linha.length === 0"
              :cpntClass="[ 'btn', 'btn-default', 'btn-sm' ]" 
              @onClick="() => { appProSitFisSimuladorSelecionarDados('contato') }">
              Contato [Todos]
              </App-Button> -->

              <!-- SETA OS DADOS DO CONTATO SELECIONADO -->
              <template v-else>
                Contato
                <App-Tabela :cpntColuna="filtros.contato.colunas" :cpntLinha="filtros.contato.linha">
                  <!-- <template v-slot:cabecalho>
                    <div style="text-align: center; color: #3875A5; font-weight: bold;">Contato</div>
                  </template> -->

                  <template v-slot:col_botao>
                    <App-Button
                    :cpntClass="[ 'btn', 'btn-danger', 'btn-sm' ]"
                    :cpntIcone="'excluir'"
                    @onClick="() => { appProSitFisSimuladorRemover('contato') }"></App-Button>
                  </template>
                </App-Tabela>
              </template>
            </div>

            
            <div :class="filtros.ncm.toggles.value === true ? '' : 'filtrar_campo' ">
              <App-Toggles :data-time="time" :class="filtros.ncm.toggles.id"
                :cpntStatus='filtros.ncm.toggles.status'
                :cpntId='filtros.ncm.toggles.id'
                :cpntClassDivField='filtros.ncm.toggles.classDivField'
                :cpntNome='filtros.ncm.toggles.nome'
                :cpntValue='filtros.ncm.toggles.value'
                :cpntDisabled='filtros.ncm.toggles.disabled'
                :cpntMostrar='filtros.ncm.toggles.mostrar'
                :cpntMensagem='filtros.ncm.toggles.mensagem'
                :cpntMensagemTipo='filtros.ncm.toggles.mensagemTipo'
                :cpntOn='filtros.ncm.toggles.on'
                :cpntOff='filtros.ncm.toggles.off'
                :cpntExplica='filtros.ncm.toggles.explica'
                :cpntWidth='filtros.ncm.toggles.width'
                :cpntTabIndex='filtros.ncm.toggles.tabIndex'
                :cpntMask='filtros.ncm.toggles.mask'
                :cpntConfig='filtros.ncm.toggles.config'
                :cpntOnChange='filtros.ncm.toggles.onChange'
                :cpntOnBlur='filtros.ncm.toggles.onBlur'
                ref='ncm_toggles'
              ></App-Toggles>
              
              <App-Input :data-time="time" :class="filtros.ncm.id" v-if="filtros.ncm.toggles.value === false"
                :cpntStatus='filtros.ncm.status'
                :cpntId='filtros.ncm.id'
                :cpntClassDivField='filtros.ncm.classDivField'
                :cpntNome='""'
                :cpntValue='filtros.ncm.value'
                :cpntAutoComplete='filtros.ncm.autocomplete'
                :cpntMask='filtros.ncm.mask'
                :cpntOptionInicialNome='filtros.ncm.optionInicialNome'
                :cpntOptionInicialValue='filtros.ncm.optionInicialValue'
                :cpntDisabled='filtros.ncm.disabled'
                :cpntMostrar='filtros.ncm.mostrar'
                :cpntExplica='filtros.ncm.explica'
                :cpntAutoFocus='filtros.ncm.autofocus'
                :cpntMensagem='filtros.ncm.mensagem'
                :cpntMensagemTipo='filtros.ncm.mensagemTipo'
                :cpntPlaceholder='filtros.ncm.placeholder'
                :cpntPosicionar='filtros.ncm.posicionar'
                :cpntOnChange='filtros.ncm.onChange'
                :cpntOnBlur='filtros.ncm.onBlur'
                ref='ncm'
              ></App-Input>
            </div> 

            <div :style="filtros.produto.linha.length === 0 ? '' : 'margin-top: 5px;'">
              <!-- CRIA O BOTÃO PARA SELECIONAR TODOS -->
              <App-Toggles :data-time="time" :class="filtros.produto.toggles.id" v-if="filtros.produto.linha.length === 0"
                :cpntStatus='filtros.produto.toggles.status'
                :cpntId='filtros.produto.toggles.id'
                :cpntClassDivField='filtros.produto.toggles.classDivField'
                :cpntNome='filtros.produto.toggles.nome'
                :cpntValue='filtros.produto.toggles.value'
                :cpntDisabled='filtros.produto.toggles.disabled'
                :cpntMostrar='filtros.produto.toggles.mostrar'
                :cpntMensagem='filtros.produto.toggles.mensagem'
                :cpntMensagemTipo='filtros.produto.toggles.mensagemTipo'
                :cpntOn='filtros.produto.toggles.on'
                :cpntOff='filtros.produto.toggles.off'
                :cpntExplica='filtros.produto.toggles.explica'
                :cpntWidth='filtros.produto.toggles.width'
                :cpntTabIndex='filtros.produto.toggles.tabIndex'
                :cpntMask='filtros.produto.toggles.mask'
                :cpntConfig='filtros.produto.toggles.config'
                :cpntOnChange='filtros.produto.toggles.onChange'
                :cpntOnBlur='filtros.produto.toggles.onBlur'
                ref='produto_toggles'
              ></App-Toggles>

              <!-- <App-Button v-if="filtros.produto.linha.length === 0"
              :cpntClass="[ 'btn', 'btn-default', 'btn-sm' ]" 
              @onClick="() => { appProSitFisSimuladorSelecionarDados('produto') }">
              Produto [Todos]
              </App-Button> -->

              <!-- SETA OS DADOS DO PRODUTO SELECIONADO -->
              <template v-else>
                Produto
                <App-Tabela :cpntColuna="filtros.produto.colunas" :cpntLinha="filtros.produto.linha">
                  <!-- <template v-slot:cabecalho>
                    <div style="text-align: center; color: #3875A5; font-weight: bold;">Produto</div>
                  </template> -->

                  <template v-slot:col_botao>
                    <App-Button
                    :cpntClass="[ 'btn', 'btn-danger', 'btn-sm' ]"
                    :cpntIcone="'excluir'"
                    @onClick="() => { appProSitFisSimuladorRemover('produto') }"></App-Button>
                  </template>
                </App-Tabela>
              </template>
            </div>
          </div>

          <div class="busca">
            <App-Button cpntIcone="fa fa-search" :cpntClass="'btn btn-primary'" @onClick="appProSitFisSimuladorPesquisar"></App-Button>
          </div>
        </div>
      </div>

      <div class="app-pro-sit-fis-sim-tabela" v-if="query !== null" :key="JSON.stringify(query)">
        <App-Produto-Sit-Fiscal :cpntConflito="true" :cpntSimulador="query" ref="tabela"></App-Produto-Sit-Fiscal>
      </div>

      <!-- SETA A TELA DE PRODUTO -->
      <RF-Dialog v-if="filtros.produto.toggles.value === false && filtros.produto.selecionar !== null"
      :cpntLargura='(tela * 0.90).toString() + "px"'
      :cpntStatus="''"
      :cpntOnFecharDialog="() => { filtros.produto.toggles.onChange(true) }">
      <template slot='titulo'>
        <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
        <b>Buscar produto</b>
      </template>

      <template slot='conteudo'>
        <App-Produto-Gerenciar :cpntSelecionar="filtros.produto.selecionar"></App-Produto-Gerenciar>
      </template>
      </RF-Dialog>

      <!-- SETA A TELA DE CONTATO -->
      <RF-Dialog v-if="filtros.contato.toggles.value === false && filtros.contato.selecionar !== null"
      :cpntLargura='(tela * 0.90).toString() + "px"'
      :cpntStatus="''"
      :cpntOnFecharDialog="() => { filtros.contato.toggles.onChange(true) }">
      <template slot='titulo'>
        <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
        <b>Buscar contato</b>
      </template>

      <template slot='conteudo'>
        <App-Contato-Gerenciar :cpntMostrarAniv="false" :cpntSelecionar="filtros.contato.selecionar"></App-Contato-Gerenciar>
      </template>
      </RF-Dialog>
    </template>
  </RF-Dialog>
</template>

<style scoped>
  .app-pro-sit-fis-sim-filtros {
    margin-top: 15px;
    width: 100%;
    /* width: calc(295px + 50px); */
    float: right;
  }
    .app-pro-sit-fis-sim-filtros > div {
      display: inline-block;
      vertical-align: top;
    }
    .app-pro-sit-fis-sim-filtros > div:first-child {
      width: calc(100% - 60px);
      margin: 0px auto;
    }
    .app-pro-sit-fis-sim-filtros > div:last-child {
      margin-left: 10px;
      min-height: 208px;
    }
      .app-pro-sit-fis-sim-filtros > div:first-child > div {
        vertical-align: bottom;
      }
      .app-pro-sit-fis-sim-filtros > div:first-child > div {
        margin-top: 22px;
      }
      .app-pro-sit-fis-sim-filtros > div.busca {
        margin-top: 22px;
        width: 50px;
        /* display: inline-block;
        vertical-align: top; */
          padding-top: 0px;
      }
        .app-pro-sit-fis-sim-filtros > div.busca > button {
          height: 238px;
          max-height: 238px;
          min-height: 238px;
          width: 100%;
        }
      .app-pro-sit-fis-sim-tabela {
        padding-top: 15px;
        clear: both;
      }

  .app-pro-sit-fis-sim-filtros > div > .filtrar_campo > div.cpnt-app-campo:first-child {
    width: calc(100% - 160px) !important;
  }
  .app-pro-sit-fis-sim-filtros > div > .filtrar_campo > div.cpnt-app-campo:not(:first-child) {
    width: 150px;
    margin-left: 10px;
  }
  .app-pro-sit-fis-sim-filtros > div > .filtrar_campo > div.cpnt-app-select {
    margin-top: -1px;
  }
</style>

<style>
  .app-pro-sit-fis-sim-filtros > div > div > div.cpnt-app-toggle,
  .app-pro-sit-fis-sim-filtros > div > div > div.cpnt-app-toggle > div {
    width: 100% !important;
    margin-bottom: 0px !important;
  }
  .app-pro-sit-fis-sim-filtros > div > div > table > tbody > tr > td.col_botao {
    width: 40px;
  }
</style>

<script>
  export default {
    props: {
      cpntDemanda: {
        typeof: String,
        defualt: function () {
          return ''
        }
      },
      cpntPDocTp: {
        typeof: String,
        defualt: function () {
          return ''
        }
      },
      cpntNCM: {
        typeof: String,
        defualt: function () {
          return ''
        }
      },
      cpntIdPro: {
        typeof: String,
        defualt: function () {
          return ''
        }
      },
      cpntIdCon: {
        typeof: String,
        defualt: function () {
          return ''
        }
      },
      cpntIdUf: {
        typeof: String,
        defualt: function () {
          return ''
        }
      },
      cpntFecharFormulario: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    components: {
      'App-Contato-Gerenciar': () => import('@/components/contato/gerenciar/Contato-Gerenciar.vue'),
      'App-Produto-Gerenciar': () => import('@/components/produto/gerenciar/Produto-Gerenciar.vue'),
      'App-Produto-Sit-Fiscal': () => import('@/components/produto/sit-fiscal/Produto-Sit-Fiscal.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        tela: window.innerWidth,
        query: null,
        filtros: {
          demanda: {
            id: 'app-pro-sit-fis-filtro--demanda',
            status: '',
            nome: 'Demanda',
            keyValue: 'id',
            keyMostra: [ 'demanda' ],
            options: [
              { id: 'dem_compra',         demanda: 'Compra' },
              { id: 'dem_dev_fornecedor', demanda: 'Devolução Fornecedor' },
              { id: 'dem_venda',          demanda: 'Venda' },
              { id: 'dem_dev_cliente',    demanda: 'Devolução Cliente' }
            ],
            optionInicialNome: '',
            mostrar: true,
            disabled: false,
            value: 'dem_venda',
            valueIni: '',
            onChange: this.appProSitFisSimuladorOnChangeValue
          },
          ncm: {
            id: 'app-pro-sit-fis-filtro--ncm',
            status: '',
            nome: 'NCM',
            mostrar: true,
            disabled: false,
            value: '',
            valueIni: '',
            onChange: this.appProSitFisSimuladorOnChangeValue,
            toggles: {
              id: 'app-pro-sit-fis-filtro--ncm-toggles',
              status: '',
              nome: 'NCM',
              on: 'Todas (menos as exceções)',
              off: 'Sel. Todos',
              disabled: false,
              value: true,
              onChange: (value) => {
                // SETA O NOVO VALOR DO CAMPO
                this.filtros.ncm.toggles.value = value

                // LIMPA O VALOR DO CAMPO
                if (value === true) {
                  this.filtros.ncm.value = ''
                }

                // VERIFICA SE DEVE HABILITAR OU NÃO O CAMPO
                this.appProSitFisSimuladorToggleDisabled('produto')
              }
            }
          },
          produto: {
            selecionar: null,
            keyValue: 'id',
            chaves: [],
            colunas: [
              { mPer: 1, chave: 'codigo', nome: 'Código' },
              { mPer: 1, chave: 'nome',   nome: 'Nome' },
              { mPer: 1, chave: 'botao',  nome: 'Excluir' }
            ],
            linha: [],
            toggles: {
              id: 'app-pro-sit-fis-filtro--produto-toggles',
              status: '',
              nome: 'Produto',
              on: 'Todos (menos as exceções)',
              off: 'Sel. Todos',
              disabled: false,
              value: true,
              onChange: (value) => {
                // SETA O NOVO VALOR DO CAMPO
                this.filtros.produto.toggles.value = value

                // SETA OS DADOS QUE DEVE SELECIONAR
                this.appProSitFisSimuladorSelecionarDados('produto')

                // LIMPA O VALOR DO CAMPO
                if (value === true) {
                  this.filtros.produto.chaves = []
                  this.filtros.produto.linha = []
                }
              }
            }
          },
          contato: {
            selecionar: null,
            keyValue: 'id',
            chaves: [],
            colunas: [
              { mPer: 1, chave: 'nome', nome: 'Nome' },
              { mPer: 1, chave: 'botao', nome: 'Excluir' }
            ],
            linha: [],
            toggles: {
              id: 'app-pro-sit-fis-filtro--contato-toggles',
              status: '',
              nome: 'Contato',
              on: 'Todos (menos as exceções)',
              off: 'Sel. Todos',
              disabled: false,
              value: true,
              onChange: (value) => {
                // SETA O NOVO VALOR DO CAMPO
                this.filtros.contato.toggles.value = value

                // SETA OS DADOS QUE DEVE SELECIONAR
                this.appProSitFisSimuladorSelecionarDados('contato')
              }
            }
          },
          estado: {
            id: 'app-pro-sit-fis-filtro--estado',
            status: '',
            nome: '',
            keyValue: 'uf',
            keyMostra: [ 'uf', ' - ', 'estado' ],
            options: [],
            optionInicialNome: '',
            mostrar: true,
            disabled: false,
            value: '',
            valueIni: '',
            onBuscarOptions: this.appProSitFisSimuladorBuscarEstados,
            onChange: this.appProSitFisSimuladorOnChangeValue,
            toggles: {
              id: 'app-pro-sit-fis-filtro--estado-toggles',
              status: '',
              nome: 'Estado',
              on: 'Todos (menos as exceções)',
              off: 'Sel. Todos',
              disabled: false,
              value: true,
              onChange: (value) => {
                // SETA O NOVO VALOR DO CAMPO
                this.filtros.estado.toggles.value = value

                // LIMPA O VALOR DO CAMPO
                if (value === true) {
                  this.filtros.estado.value = ''
                }

                // VERIFICA SE DEVE HABILITAR OU NÃO O CAMPO
                this.appProSitFisSimuladorToggleDisabled('id_p_pais')
                this.appProSitFisSimuladorToggleDisabled('contato')
              }
            }
          },
          id_p_pais: {
            id: 'app-pro-sit-fis-filtro--id_p_pais',
            status: '',
            nome: '',
            keyValue: 'cPais',
            keyMostra: [ 'xPais', ' (', 'cPais', ')' ],
            options: [],
            optionInicialNome: '',
            mostrar: true,
            disabled: false,
            value: '',
            valueIni: '',
            onBuscarOptions: this.appProSitFisSimuladorBuscarPais,
            onChange: this.appProSitFisSimuladorOnChangeValue,
            toggles: {
              id: 'app-pro-sit-fis-filtro--id_p_pais-toggles',
              status: '',
              nome: 'País',
              on: 'Todos (menos as exceções)',
              off: 'Sel. Todos',
              disabled: false,
              value: true,
              onChange: (value) => {
                // SETA O NOVO VALOR DO CAMPO
                this.filtros.id_p_pais.toggles.value = value

                // LIMPA O VALOR DO CAMPO
                if (value === true) {
                  this.filtros.id_p_pais.value = ''
                }

                // VERIFICA SE DEVE HABILITAR OU NÃO O CAMPO
                this.appProSitFisSimuladorToggleDisabled('estado')
                this.appProSitFisSimuladorToggleDisabled('contato')
              }
            }
          },
          modelo: {
            id: 'app-pro-sit-fis-filtro--modelo',
            status: '',
            nome: 'Modelo NF',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            options: [
              { id: 'NFe', nome: 'NF-e' },
              { id: 'NFCe', nome: 'NFC-e' }
            ],
            optionInicialNome: 'Selecione',
            mostrar: true,
            disabled: false,
            value: { id: 'NFe', nome: 'NF-e' },
            valueIni: { id: 'NFe', nome: 'NF-e' },
            onChange: this.appProSitFisSimuladorOnChangeValue
          }
        }
      }
    },
    mounted: function () {
      this.appProSitFisSimuladorIniciar()
    },
    methods: {
      appProSitFisSimuladorIniciar: function () {
        // SETA O STATUS DA PAGINA
        this.appProSitFisSimuladorSetarStatusGeral('carregando')

        // VERIFICA SE TEM VALOR PARA SETAR NO CAMPO
        if ([ '', null, undefined ].indexOf(this.cpntDemanda) === -1) {
          this.filtros.demanda.value = this.cpntDemanda
        }

        // VERIFICA SE TEM VALOR PARA SETAR NO CAMPO
        if ([ '', null, undefined ].indexOf(this.cpntPDocTp) === -1) {
          this.filtros.modelo.value = this.cpntPDocTp
        }

        // VERIFICA SE TEM VALOR PARA SETAR NO CAMPO
        if ([ '', null, undefined ].indexOf(this.cpntNCM) === -1) {
          this.filtros.ncm.value = this.cpntNCM
          this.filtros.ncm.toggles.onChange(false)
        }

        // VERIFICA SE TEM VALOR PARA SETAR NO CAMPO
        if ([ '', null, undefined ].indexOf(this.cpntIdPro) === -1) {
          // SETA OS DADOS RECEBIDOS
          this.filtros.produto.chaves = [ this.cpntIdPro ]

          // // HABILITA O CAMPO NOVAMENTE
          // this.filtros.produto.toggles.onChange(false)

          // FAZ A BUSCA DO CADASTRO SELECIONADO
          this.appProSitFisSimuladorBuscarProduto(this.cpntIdPro)
        }

        // VERIFICA SE TEM VALOR PARA SETAR NO CAMPO
        if ([ '', null, undefined ].indexOf(this.cpntIdCon) === -1) {
          // SETA OS DADOS RECEBIDOS
          this.filtros.contato.chaves = [ this.cpntIdCon ]

          // // HABILITA O CAMPO NOVAMENTE
          // this.filtros.contato.toggles.onChange(false)

          // FAZ A BUSCA DO CADASTRO SELECIONADO
          this.appProSitFisSimuladorBuscarContato(this.cpntIdCon)
        }

        // VERIFICA SE TEM VALOR PARA SETAR NO CAMPO
        if ([ '', null, undefined ].indexOf(this.cpntIdUf) === -1) {
          // SETA O VALOR DO CAMPO
          this.filtros.estado.value = this.cpntIdUf

          // PROCURA OS VALORES SELECIONADOS
          this.appProSitFisSimuladorBuscarEstados(() => {
            // PEGA O VALOR SELECIONADO
            this.filtros.estado.value = this.filtros.estado.options.filter(item => item.uf === this.cpntIdUf)[0]

            // HABILITA O CAMPO NOVAMENTE
            this.filtros.estado.toggles.onChange(false)

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        }

        // VERIFICA SE TEM ALGUMA COISA A SER PESQUISADO
        if ([ '', null, undefined ].indexOf(this.cpntDemanda) === -1 || [ '', null, undefined ].indexOf(this.cpntNCM) === -1 || [ '', null, undefined ].indexOf(this.cpntIdPro) === -1 || [ '', null, undefined ].indexOf(this.cpntIdCon) === -1 || [ '', null, undefined ].indexOf(this.cpntIdUf) === -1) {
          setTimeout(() => { this.appProSitFisSimuladorPesquisar() }, 500)
        }

        // SETA O STATUS DA PAGINA
        this.appProSitFisSimuladorSetarStatusGeral('')
      },
      appProSitFisSimuladorSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      appProSitFisSimuladorFechar: function (atualizar = false) {
        this.cpntFecharFormulario(atualizar)
      },
      appProSitFisSimuladorSimuladorAdicionar: function (tipo, dados) {
        // SETA O ID SELECIONADO
        if (this.filtros[tipo].chaves.indexOf(dados[this.filtros[tipo].keyValue]) === -1) {
          this.filtros[tipo].chaves.push(dados[this.filtros[tipo].keyValue])
        }

        // ADICIONA OS DADOS RECEBIDOS
        this.filtros[tipo].linha.push(dados)

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      appProSitFisSimuladorSelecionarDados: function (tipo) {
        this.filtros[tipo].selecionar = (dados) => { this.appProSitFisSimuladorSetarSelecao(tipo, dados) }
      },
      appProSitFisSimuladorSetarSelecao: function (tipo, valores) {
        if ([ '', null, undefined ].indexOf(valores) === -1) {
          // ADICIONA OS DADOS SOLICITADOS
          this.appProSitFisSimuladorSimuladorAdicionar(tipo, valores)
  
          // VERIFICA SE TEM QUE CONVERTER ALGUM VALOR
          switch (tipo) {
            case 'contato':
              var finalizar = () => {
                // VERIFICA SE TEM O PAIS SETADO
                if ([ '', null, undefined, '0', 0 ].indexOf(valores.id_p_pais) !== -1) {
                  valores.id_p_pais = '1058'
                }

                // VERIFICA SE O CONTATO TEM O PAIS DIFERENTE DE BRASIL
                if (valores.id_p_pais === '1058') {
                  // VERIFICA SE DEVE PEGAR O ESTADO DO MEU CADASTRO
                  if ([ '', null, undefined ].indexOf(valores.id_estado) !== -1 && [ '', null, undefined ].indexOf(this.$store.state.licenca.uf) === -1) {
                    valores.id_estado = this.$store.state.licenca.uf
                    valores.id_estado_estado = this.$store.state.UFs.filter(item => item.uf === this.$store.state.licenca.uf)[0].estado
                  }
    
                  // VERIFICA SE TEM ESTADO A SER SELECIONADO
                  if ([ '', null, undefined ].indexOf(valores.id_estado) === -1) {
                    // FECHA A TELA DE SELEÇÃO
                    this.filtros.estado.toggles.onChange(false)
    
                    // MANDA ATUALIZAR O VALOR DO CAMPO
                    this.appProSitFisSimuladorOnChangeValue({ uf: valores.id_estado, estado: valores.id_estado_estado }, this.filtros.estado.id)
                  }
                } else {
                  // FECHA A TELA DE SELEÇÃO
                  this.filtros.id_p_pais.toggles.onChange(false)
  
                  // MANDA ATUALIZAR O VALOR DO CAMPO
                  this.appProSitFisSimuladorOnChangeValue({ cPais: valores.id_p_pais, xPais: valores.id_p_pais_xPais }, this.filtros.id_p_pais.id)
                }
  
                // MANDA ATUALIZAR O CAMPO
                setTimeout(() => {
                  this.appProSitFisSimuladorToggleDisabled('id_p_pais')
                  this.appProSitFisSimuladorToggleDisabled('estado')
                }, 500)
              }

              // VERIFICA SE JÁ TEM OS PAIS
              if (this.filtros.id_p_pais.options.length === 0) {
                this.appProSitFisSimuladorBuscarPais(finalizar)
              } else {
                finalizar()
              }
              break
  
            case 'produto':
              if ([ '', null, undefined ].indexOf(valores.ncm) === -1) {
                // FECHA A TELA DE SELEÇÃO
                this.filtros.ncm.toggles.onChange(false)
                
                // MANDA ATUALIZAR O VALOR DO CAMPO
                this.appProSitFisSimuladorOnChangeValue(valores.ncm, this.filtros.ncm.id)
              }

              // MANDA ATUALIZAR O CAMPO
              setTimeout(() => { this.appProSitFisSimuladorToggleDisabled('ncm') }, 500)
              break
          }

          // FECHA A TELA DE SELEÇÃO
          this.filtros[tipo].selecionar = null

          // FECHA A TELA DE SELEÇÃO
          this.filtros[tipo].toggles.value = false

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }
      },
      appProSitFisSimuladorRemover: function (tipo) {
        // SETA O ID SELECIONADO
        this.filtros[tipo].chaves = []

        // ADICIONA OS DADOS RECEBIDOS
        this.filtros[tipo].linha = []

        // FECHA A TELA DE SELEÇÃO
        this.filtros[tipo].toggles.value = true

        // FECHA A TELA DE SELEÇÃO
        this.filtros[tipo].selecionar = null

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA SE DEVE TRAVAR O CAMPO
        switch (tipo) {
          case 'contato':
            // FECHA A TELA DE SELEÇÃO
            this.filtros.estado.toggles.onChange(true)

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()

            // MANDA ATUALIZAR O CAMPO
            this.appProSitFisSimuladorToggleDisabled('id_p_pais')
            this.appProSitFisSimuladorToggleDisabled('estado')
            this.appProSitFisSimuladorToggleDisabled('contato')
            break

          case 'produto':
            // FECHA A TELA DE SELEÇÃO
            this.filtros.ncm.toggles.onChange(true)

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()

            // MANDA ATUALIZAR O CAMPO
            this.appProSitFisSimuladorToggleDisabled('ncm')
            break
        }
      },
      appProSitFisSimuladorOnChangeValue: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
        var index = id.split('--')[1]

        // SETA O VALOR RECEBIDO
        this.filtros[index].value = value

        // REMOVE A MENSAGEM DE ERRO
        this.filtros[index].mensagem = ''
        this.filtros[index].mensagemTipo = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA SE DEVE TRAVAR O CAMPO
        switch (index) {
          case 'estado':
            this.appProSitFisSimuladorToggleDisabled('id_pais')
            this.appProSitFisSimuladorToggleDisabled('contato')
            break

          case 'id_p_pais':
            this.appProSitFisSimuladorToggleDisabled('estado')
            this.appProSitFisSimuladorToggleDisabled('contato')
            break

          case 'ncm':
            this.appProSitFisSimuladorToggleDisabled('produto')
            break
        }
      },
      appProSitFisSimuladorToggleDisabled: function (campo) {
        switch (campo) {
          case 'produto':
            this.filtros.produto.toggles.disabled = this.filtros.ncm.toggles.value === false // && this.filtros.ncm.value !== ''
            break

          case 'ncm':
            this.filtros.ncm.toggles.disabled = this.filtros.produto.toggles.value === false // && this.filtros.produto.chaves.length >= 1
            this.filtros.ncm.disabled = this.filtros.ncm.toggles.disabled
            break

          case 'contato':
            this.filtros.contato.toggles.disabled = this.filtros.estado.toggles.value === false || this.filtros.id_p_pais.toggles.value === false
            break

          case 'estado':
            this.filtros.estado.toggles.disabled = this.filtros.contato.toggles.value === false || this.filtros.id_p_pais.toggles.value === false
            this.filtros.estado.disabled = this.filtros.estado.toggles.disabled
            break
            
          case 'id_p_pais':
            this.filtros.id_p_pais.toggles.disabled = this.filtros.estado.toggles.value === false || this.filtros.contato.toggles.value === false
            this.filtros.id_p_pais.disabled = this.filtros.id_p_pais.toggles.disabled
            break
        }
      },
      appProSitFisSimuladorBuscarPais: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }

          // SETA O NOME DOS CAMPOS
          queryGet.field = { cPais: null, xPais: null, img: null }

          // ORDENA 
          queryGet.order = { xPais: 'asc' }

          // SETA O STATUS DO VENDEDOR
          queryGet.where = { f: 'cPais', o: '<>', v: '1058' }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/pro-pais/get', 'POST', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.appProSitFisSimuladorBuscarPais(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.filtros.id_p_pais.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else if (total === 0) {
          // SETA OS VALORES RECEBIDOS
          this.filtros.id_p_pais.onBuscarOptions = null

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        } else {
          // SETA O CAMINHO DA IMAGEM DO BANCO
          for (var indexR in registros) {
            registros[indexR]._img = '/img/bandeira/' + registros[indexR].img + '.png'
          }

          // SETA OS VALORES RECEBIDOS
          this.$set(this.filtros.id_p_pais, 'options', registros)

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      appProSitFisSimuladorBuscarEstados: function (callback) {
        // SETA OS VALORES RECEBIDOS
        this.filtros.estado.options = this.$store.state.UFs

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // EXECUTA A FUNÇÃO CALLBACK
        callback()
      },
      appProSitFisSimuladorPesquisar: function () {
        // INICIA A VARIAVEL WHERE
        var filtros = {}

        // SETA A NCM RECEBIDA
        filtros.p_doc_tp = this.filtros.modelo.value
        filtros.p_doc_tp = typeof filtros.p_doc_tp === 'string' ? filtros.p_doc_tp : filtros.p_doc_tp.id

        // VERIFICA SE TEM MODELO SELECIONADO
        if ([ '', null, undefined ].indexOf(filtros.p_doc_tp) !== -1) {
          // APRESENTA A MENSAGEM DE ERRO MONTADA
          this.$store.state.msgWarn('WEB [400]: Selecione o modelo de NF que deseja utilizar no simulador.', 'warning')
        } else {
          // SETA A NCM RECEBIDA
          filtros.demanda = this.filtros.demanda.value
          filtros.demanda = typeof filtros.demanda === 'string' ? filtros.demanda : filtros.demanda.id
  
          // SETA A NCM RECEBIDA
          filtros.ncm = this.filtros.ncm.value
  
          // SETA A NCM RECEBIDA
          filtros.id_pro = this.filtros.produto.chaves
          filtros.id_pro = filtros.id_pro.join()
  
          // SETA A NCM RECEBIDA
          filtros.id_con = this.filtros.contato.chaves
          filtros.id_con = filtros.id_con.join()
    
          // SETA A LICENÇA DE USO DO MEU CADASTRO
          if (filtros.p_doc_tp === 'NFCe') {
            filtros.id_uf = this.$store.state.licenca.uf
          } else {
            filtros.id_uf = this.filtros.estado.value
            filtros.id_uf = typeof filtros.id_uf === 'string' ? filtros.id_uf : filtros.id_uf.uf
          }
    
          // SETA O PAIS QUE DEVE BUSCAR
          if (filtros.p_doc_tp === 'NFCe') {
            filtros.id_p_pais = '1058'
          } else {
            filtros.id_p_pais = this.filtros.id_p_pais.value
            filtros.id_p_pais = typeof filtros.id_p_pais === 'string' ? filtros.id_p_pais : filtros.id_p_pais.cPais
          }
          if ([ '', null, undefined, 0 ].indexOf(filtros.id_p_pais) !== -1) {
            filtros.id_p_pais = '0'
          }
  
          // VERIFICAR SE TEM QUERY
          if (JSON.stringify(this.query) !== JSON.stringify(filtros)) {
            // SETA O VALOR QUE DEVE SER COLOCADO NA PESQUISA
            this.query = filtros
    
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          } else if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1) {
            setTimeout(() => { this.$refs.tabela.proSitFisTabBuscarLinhas() }, 100)
          }
        }
      },
      appProSitFisSimuladorBuscarProduto: function (id) {
        // INICIA O QUERYGET
        var queryGet = { type: 'list', limit: { row: 0, qty: 1000 } }

        // SETA OS CAMPOS QUE DEVE BUSCAR
        queryGet.field = { id: null, codigo: null, nome: null }

        // SETA O WHERE QUE DEVE REALIZAR
        queryGet.where = { f: 'id', o: 'in', v: id }

        // CHAMA FUNÇÃO PARA COMUNICAR COM API
        this.$store.state.comunicaAPI('/produto/get', 'POST', queryGet, (retorno) => {
          this.appProSitFisSimuladorSetarSelecao('produto', retorno.data[0])
        }, this.appProSitFisSimuladorSetarStatusGeral)
      },
      appProSitFisSimuladorBuscarContato: function (id) {
        // INICIA O QUERYGET
        var queryGet = { type: 'list', limit: { row: 0, qty: 1000 } }

        // SETA OS CAMPOS QUE DEVE BUSCAR
        queryGet.field = { id: null, nome: null, id_estado: { j: { estado: null } }, id_p_pais: { j: { xPais: null } }, pessoa: null }

        // SETA O WHERE QUE DEVE REALIZAR
        queryGet.where = { f: 'id', o: 'in', v: id }

        // CHAMA FUNÇÃO PARA COMUNICAR COM API
        this.$store.state.comunicaAPI('/contato/get', 'POST', queryGet, (retorno) => {
          this.appProSitFisSimuladorSetarSelecao('contato', retorno.data[0])
        }, this.appProSitFisSimuladorSetarStatusGeral)
      }
    }
  }
</script>
